import { cn } from '@avanta/shared/utils/cn';

interface SectionProps {
  title?: React.ReactNode;
  titleId?: string;
  className?: string;
  containerClassName?: string;
}

export const StepSection = ({
  title,
  titleId,
  className,
  containerClassName,
  children,
}: React.PropsWithChildren<SectionProps>): React.ReactElement => (
  <div className={cn('flex flex-col gap-4', containerClassName)}>
    {title && (
      <h2 id={titleId} className="leading-5 font-medium text-sm am-lg:text-base">
        {title}
      </h2>
    )}
    <div className={className}>{children}</div>
  </div>
);
